import React from 'react';
import Layout from '../../scaffolding/Layout';

const FindACoach = () => {
  return <Layout>Find a coach</Layout>;
};

export default FindACoach;
